import { type Store } from 'redux';
import { showMessage } from './store/message-actions';

/** `props` is whatever the message renderer for `type` expects. */
export default (store: Pick<Store, 'dispatch'>) => (type: string, props?: unknown) =>
  store.dispatch(showMessage(type, props));
